import UiValidatedJsonModeMixin from "../UiValidatedJsonModeMixin";

// @vue/component
export default {
  name: "ModeSingle",
  mixins: [
    UiValidatedJsonModeMixin
  ],
};
